var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_785_3095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0019 10.3659L21.182 33.2059L12.702 24.7259L15.522 21.9059L21.182 27.5659L41.1819 7.56586L44.0019 10.3659ZM39.582 20.4459C39.8419 21.5859 40.0019 22.7859 40.0019 24.0059C40.0019 32.8458 32.8419 40.0058 24.002 40.0058C15.162 40.0058 8.00195 32.8458 8.00195 24.0059C8.00195 15.1659 15.162 8.00586 24.002 8.00586C27.162 8.00586 30.082 8.92586 32.562 10.5059L35.4419 7.62586C32.2019 5.34586 28.2619 4.00586 24.002 4.00586C12.962 4.00586 4.00195 12.9659 4.00195 24.0059C4.00195 35.0458 12.962 44.0058 24.002 44.0058C35.042 44.0058 44.0019 35.0458 44.0019 24.0059C44.0019 21.6259 43.5619 19.3459 42.8019 17.2259L39.582 20.4459Z",
    fill: "#16A02C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_785_3095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.87f8afe8c648d716f99ec20db7bec190.svg";
export { ForwardRef as ReactComponent };